import { translation as t } from "./helpers";

const urlCreate = `/api/app/create-donate?api_key=${TheApp.CurrentContext.app.jsApiKey}`;

let elements;
let _elem, submit, spinner, buttonText;
const _stripe = Stripe(TheApp.StripePublishableKey);

export default function stripe({
    elem,
    data,
    onSuccess = null,
    onCancel = null,
    onError = null,
    onCreateError = null,
    setLoading = null
}) {
    _elem = elem;
    submit = elem.querySelector("#submit");
    spinner = elem.querySelector("#spinner");
    buttonText = elem.querySelector("#button-text");
    
    const initialize = async () => {
        const res = await fetch(urlCreate, {
            method: "post",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
                ContentLocale: TheApp.ContentLocale,
                Data: data
            })
        });
        const _data = await res.json();

        if (!_data.Success) {
            showMessage(t("ERROR.StripeCreate") + " " + data.error);
            setLoading(false);
            if (_data?.Errors?.length > 0) {
                const { Errors } = _data;
                onCreateError?.({ Errors });
            }

            return;
        }

        const clientSecret = _data.PaymentClientSecret;
        const appearance = { theme: "stripe" };
        elements = _stripe.elements({ appearance, clientSecret, locale: TheApp.Env.LocaleShort });
        const paymentElementOptions = { layout: "accordion" };
        const paymentElement = elements.create("payment", paymentElementOptions);
        paymentElement.mount(elem.querySelector("#payment-element"));
        submit.classList.remove("is-disabled");
        submit.removeAttribute("inert");
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading?.(true);

        const { error } = await _stripe.confirmPayment({
            elements,
            confirmParams: { return_url: `${TheApp.Env.BaseUrlNls}?transaction=success` }
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            showMessage(error.message);
        } else {
            showMessage(t("ERROR.StripeUnexpected"));
        }

        setLoading?.(false);
    }    

    initialize();
    submit.addEventListener("click", handleSubmit);
}

// ------- UI helpers -------
function showMessage(messageText) {
    const messageContainer = _elem.querySelector("#payment-message");

    messageContainer.classList.remove("hidden");
    messageContainer.textContent = messageText;

    setTimeout(function () {
        messageContainer.classList.add("hidden");
        messageContainer.textContent = "";
    }, 4000);
}